import { AnchorElementsSource } from '../types/AnchorElementsSource';
import { DatapointStatus, logUsage, PerformanceDatapoint } from 'owa-analytics';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import getSharingInfoResponse from 'owa-service/lib/factory/getSharingInfoResponse';
import { lazyGetSharingInformation as lazyGetSharingInformationService } from 'owa-sharing-data';

export async function getSharingInformation(
    url: string,
    anchorElementsSource: AnchorElementsSource,
    shouldBeautify: boolean,
    shouldRehydrate: boolean
): Promise<GetSharingInfoResponse> {
    let response: GetSharingInfoResponse;
    let errorType: string = null;

    const expectedErrorType = getExpectedErrorType(url);
    const datapoint: PerformanceDatapoint = new PerformanceDatapoint(
        'GetSharingInformationForLink'
    );
    datapoint.addCustomData({
        anchorElementsSource: anchorElementsSource.toString(),
        shouldBeautify: shouldBeautify,
        shouldRehydrate: shouldRehydrate,
        expectedErrorType: expectedErrorType,
    });

    try {
        const getSharingInformationService = await lazyGetSharingInformationService.import();
        response = await getSharingInformationService(url);
    } catch (error) {
        errorType = error.fetchErrorType;
        response = getSharingInfoResponse({
            ResultCode: AttachmentResultCode.GenericFailure,
        });
    }

    if (response.ResultCode !== AttachmentResultCode.Success) {
        // Keeping this redundent datapoint while the new one rolls out.
        // VSO 53412 to track removing this
        logUsage('GetSharingInformationFailure', {
            errorType: errorType,
            resultCode: response.ResultCode,
            anchorElementsSource: anchorElementsSource.toString(),
            shouldBeautify: shouldBeautify,
            shouldRehydrate: shouldRehydrate,
            expectedErrorType: expectedErrorType,
        });

        datapoint.addCustomData({
            errorType: errorType,
            resultCode: response.ResultCode,
        });
        datapoint.endWithError(DatapointStatus.ServerError);
    } else {
        datapoint.addCustomData({
            errorType: null,
            resultCode: response.ResultCode,
        });
        datapoint.end();
    }
    return response;
}

function getExpectedErrorType(url: string): string {
    // some of the string checks might have different cases. This lets us check al of them consistently.
    const lowerCaseUrl = url.toLowerCase();
    const stringsToCheck = ['onedrive.aspx', 'onenote.aspx', 'allitems.aspx', 'all.aspx', 'sites'];
    for (const str of stringsToCheck) {
        if (lowerCaseUrl.indexOf(str) !== -1) {
            return str;
        }
    }
    return 'NoErrorExpected';
}
